import {
	useQuery,
	useInfiniteQuery,
	useQueryClient,
	useMutation,
} from "react-query";
import { toast } from "react-toastify";
import API from "./utils/api";
import {
	AnnouncementReadEventResponseDto,
	AnnouncementReadEventResponsePaginator,
	CreateAnnouncementReadEventDto,
	QueryAnnouncementReadEventSummaryDto,
} from "../models/announcement-read-event.dto";
import ENDPOINTS from "./utils/endpoints";

export function useGetAnnouncementReadEventSummaryList(
	options?: QueryAnnouncementReadEventSummaryDto
) {
	const url = ENDPOINTS.HR.ANNOUNCEMENT_READ_EVENTS.SUMMARY_LIST;
	const request = (options: QueryAnnouncementReadEventSummaryDto) =>
		API.HrAPI.getAnnouncementReadEventSummaryList(options);

	const { data, isLoading, error, refetch } = useQuery<
		AnnouncementReadEventResponsePaginator,
		Error
	>(
		[url, options],
		({ queryKey, pageParam }) =>
			request(Object.assign({}, queryKey[1], pageParam)),
		{ ...API.Handlers.pageParamOption }
	);

	return { data, isLoading, error, refetch };
}

export function useGetMyAnnouncementReadEventSummary(id: number) {
	const url = ENDPOINTS.HR.ANNOUNCEMENT_READ_EVENTS.SUMMARY;
	const request = API.HrAPI.getAnnouncementReadEventSummary(id);

	const { data, isLoading, error } = useQuery<
		{ data: AnnouncementReadEventResponseDto },
		Error
	>([url, id], () => request, { enabled: !!id });

	return { data, isLoading, error };
}

export function useGetAnnouncementReadEventDetail() {
	return useMutation(
		(id: number) => API.HrAPI.getAnnouncementReasEventDetail(id),
		{
			onSuccess: (response) => {},
			onError: API.Handlers.onErrorHandler,
		}
	);
}

export function useCreateAnnouncementReadEvent() {
	const queryClient = useQueryClient();

	return useMutation(
		({
			id,
			payload,
		}: {
			id: number;
			payload: CreateAnnouncementReadEventDto;
		}) => API.HrAPI.createAnnoucementReadEvent(id, payload),
		{
			onSuccess: () => {
				// toast.success('Record created successfully');
				queryClient.invalidateQueries(
					ENDPOINTS.HR.ANNOUNCEMENT_READ_EVENTS.SUMMARY_LIST
				);
			},
			onError: API.Handlers.onErrorHandler,
		}
	);
}
